export default __webpack_public_path__ + "static/media/provesional_restoration_upper_12_4@2x.a97e0966.png";